import { BaseQueryApi, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { showGlobalError } from "../slices";

import {
    AlertTriangle,
    ServerCrash,
    WifiOff,
} from "lucide-react";

export type GlobalErrorContent = {
    title: string;
    description: string;
    status: string;
    icon: typeof AlertTriangle;
    buttonText: string;
};

export const getGlobalErrorContent = (
    error?: FetchBaseQueryError | null
): GlobalErrorContent => {
    switch (error?.status) {
        case "FETCH_ERROR":
            return {
                title: "No Internet Connection",
                description:
                    "Please check your internet connection and try again.",
                status: "Network Error",
                icon: WifiOff,
                buttonText: "Try Again",
            };

        case "TIMEOUT_ERROR":
            return {
                title: "Request Timed Out",
                description:
                    "The server took too long to respond. Please try again.",
                status: "Timeout",
                icon: AlertTriangle,
                buttonText: "Retry",
            };

        case 500:
            return {
                title: "Internal Server Error",
                description:
                    "An unexpected error occurred on our servers.",
                status: "500",
                icon: ServerCrash,
                buttonText: "Reload",
            };

        case 502:
            return {
                title: "Bad Gateway",
                description:
                    "The server received an invalid response.",
                status: "502",
                icon: ServerCrash,
                buttonText: "Reload",
            };

        case 503:
            return {
                title: "Service Unavailable",
                description:
                    "The service is temporarily unavailable.",
                status: "503",
                icon: ServerCrash,
                buttonText: "Reload",
            };

        default:
            return {
                title: "Something Went Wrong",
                description:
                    "An unexpected error occurred. Please try again later.",
                status: "Unknown",
                icon: AlertTriangle,
                buttonText: "Reload",
            };
    }
};

export const handleGlobalError = (
    error: FetchBaseQueryError | undefined,
    api: BaseQueryApi
) => {
    if (!error) return;

    const status = error.status;

    if (
        status === "FETCH_ERROR" ||
        status === "TIMEOUT_ERROR" ||
        (typeof status === "number" &&
            [500, 502, 503].includes(status))
    ) {
        api.dispatch(showGlobalError(error));
    }
};